
import { defineComponent, onMounted, reactive, watch, PropType } from 'vue'

// @components
import NewButton from '@/ui-kit/NewButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

// @module-components
import CarsMoreModal from '@/modules/NewDispatcher/components/CarsMoreModal/index.vue'
import CarsPrediction from '@/modules/NewDispatcher/components/CarsPrediction/index.vue'

// @types
import { PredictionCar } from '@/new-services/types/prediction'

// @services
import predictionAPI from '@/new-services/prediction.service'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        NewButton,
        Loader,
        CarsMoreModal,
        CarsPrediction,
    },
    props: {
        dispatcherSectorIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            prediction_cars: [] as PredictionCar[],
        })

        const cars_state = reactive({
            is_opened: false,
            is_loading: false,
        })

        const loadPredictionCars = async () => {
            if (!props.dispatcherSectorIds.length) {
                state.prediction_cars = []
                return
            }

            try {
                state.is_loading = true

                const response = await predictionAPI.getPredictionCars({
                    dispatcherSectorIds: props.dispatcherSectorIds,
                })
                state.prediction_cars = response.data.data.cars

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении данных прогнозирования авто произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const toggleMore = () => {
            cars_state.is_opened = !cars_state.is_opened
        }

        //

        onMounted(loadPredictionCars)

        watch(() => props.dispatcherSectorIds, loadPredictionCars)

        return {
            state,
            cars_state,
            //
            loadPredictionCars,
            toggleMore,
        }
    },
})
